module.exports = __webpack_public_path__ + "media/images/login-bg3-1cc26341c47bfe54c4339f0839ff3052.svg";